import { useSettings } from 'api/company/useSettings'
import { MainPage } from 'components/templates/MainPage'
import { AuthState } from 'recoil/atoms/auth.atom'
import { useRecoilValue } from 'recoil'
import { Navigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

const formatYen = (value: number): string => {
  return `¥${value.toLocaleString('ja-JP')}`
}

export const SettingsPage = (): JSX.Element => {
  const auth = useRecoilValue(AuthState)
  const { data } = useSettings()

  const [monthlySalesTarget, setMonthlySalesTarget] = useState<number>(0)
  const [yearlySalesTarget, setYearlySalesTarget] = useState<number>(0)
  const [fiscalStartMonth, setFiscalStartMonth] = useState<1 | 4>(4)

  useEffect(() => {
    if (!data) return
    setMonthlySalesTarget(data.monthlySalesTarget)
    setYearlySalesTarget(data.yearlySalesTarget)
    setFiscalStartMonth(data.fiscalStartMonth)
  }, [data])

  if (auth !== 'ADMIN') {
    return <Navigate to={'/dashboard'} replace />
  }

  return (
    <MainPage>
      <div className={'space-y-5'}>
        <section className={'rounded-md border bg-white p-5 shadow-sm'}>
          <h2 className={'text-base font-bold text-gray-700'}>売上目標設定</h2>

          <div className={'mt-5 space-y-5'}>
            <div>
              <label
                className={'mb-1 block text-sm font-semibold text-gray-700'}
              >
                月次売上目標（全社）
              </label>
              <input
                type={'number'}
                className={
                  'w-full max-w-md rounded border border-gray-300 px-3 py-2 text-sm'
                }
                value={monthlySalesTarget}
                onChange={(e) => {
                  setMonthlySalesTarget(Number(e.target.value || 0))
                }}
              />
              <p className={'mt-1 text-xs text-gray-500'}>
                現在値: {formatYen(monthlySalesTarget)}
              </p>
            </div>

            <div>
              <label
                className={'mb-1 block text-sm font-semibold text-gray-700'}
              >
                年間売上目標（全社）
              </label>
              <input
                type={'number'}
                className={
                  'w-full max-w-md rounded border border-gray-300 px-3 py-2 text-sm'
                }
                value={yearlySalesTarget}
                onChange={(e) => {
                  setYearlySalesTarget(Number(e.target.value || 0))
                }}
              />
              <p className={'mt-1 text-xs text-gray-500'}>
                現在値: {formatYen(yearlySalesTarget)}
              </p>
            </div>

            <div>
              <label
                className={'mb-1 block text-sm font-semibold text-gray-700'}
              >
                会計年度
              </label>
              <select
                className={
                  'w-full max-w-xs rounded border border-gray-300 px-3 py-2 text-sm'
                }
                value={String(fiscalStartMonth)}
                onChange={(e) => {
                  setFiscalStartMonth(
                    (Number(e.target.value) === 1 ? 1 : 4) as 1 | 4
                  )
                }}
              >
                <option value={'4'}>4月始まり</option>
                <option value={'1'}>1月始まり</option>
              </select>
              <p className={'mt-1 text-xs text-gray-500'}>
                会計年度の開始月を設定します
              </p>
            </div>
          </div>

          <div className={'mt-8 border-t border-gray-200 pt-5'}>
            <div className={'flex gap-3'}>
              <button
                type={'button'}
                className={
                  'rounded bg-[#4C958B] px-6 py-2 text-sm font-semibold text-white hover:brightness-110'
                }
              >
                保存
              </button>
              <button
                type={'button'}
                className={
                  'rounded border border-gray-300 bg-white px-6 py-2 text-sm text-gray-700 hover:bg-gray-100'
                }
              >
                キャンセル
              </button>
            </div>
          </div>

          <div className={'mt-8 rounded bg-gray-50 p-4'}>
            <h3 className={'text-sm font-bold text-gray-700'}>
              今後追加予定の機能
            </h3>
            <ul
              className={'mt-2 list-disc space-y-1 pl-5 text-sm text-gray-600'}
            >
              <li>担当者別目標設定</li>
              <li>部門別目標設定</li>
              <li>予算管理（人件費、経費等）</li>
              <li>KPI目標設定（商談数、成約率等）</li>
              <li>通知設定（目標未達時のアラート等）</li>
            </ul>
          </div>
        </section>
      </div>
    </MainPage>
  )
}
